export default __webpack_public_path__ + "static/media/view2_month_province.e0df7a4f.csv";